"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _chunkB2edacfb = require("./chunk-b2edacfb.js");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _layout = require("./layout.js");

require("./chunk-b15f6972.js");

require("./chunk-6104512b.js");

require("./chunk-76875e58.js");

require("./chunk-cb015231.js");

require("./chunk-f2932d1d.js");

require("./chunk-eb19ede6.js");

require("./chunk-8219403d.js");

require("./chunk-48de8464.js");

require("./chunk-e8276423.js");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = (0, _chunkB2edacfb.a)(["\n  display: flex;\n  flex-direction: row;\n\n  width: calc(100% + 120px);\n  margin-left: -60px;\n  margin-right: -60px;\n  padding: 0 60px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var TabBar = function (_PureComponent) {
  (0, _chunkB2edacfb.f)(TabBar, _PureComponent);

  function TabBar() {
    (0, _chunkB2edacfb.b)(this, TabBar);
    return (0, _chunkB2edacfb.d)(this, (0, _chunkB2edacfb.e)(TabBar).apply(this, arguments));
  }

  (0, _chunkB2edacfb.c)(TabBar, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          value = _this$props.value,
          onChange = _this$props.onChange,
          boxProps = (0, _chunkB2edacfb.j)(_this$props, ["value", "onChange"]);
      return _react.default.createElement(TabBar.Context.Provider, {
        value: {
          value: value,
          onChange: onChange
        }
      }, _react.default.createElement(StyledTabBar, boxProps, this.props.children));
    }
  }]);
  return TabBar;
}(_react.PureComponent);

(0, _chunkB2edacfb.h)(TabBar, "displayName", "CTab.Bar");
(0, _chunkB2edacfb.h)(TabBar, "Context", _react.default.createContext({
  value: null,
  onChange: function onChange() {}
}));
(0, _chunkB2edacfb.h)(TabBar, "propTypes", {
  value: _propTypes.default.string,
  onChange: _propTypes.default.func
});
var StyledTabBar = (0, _styledComponents.default)(_layout.Box).withConfig({
  displayName: "TabBar__StyledTabBar",
  componentId: "khoncr-0"
})(_templateObject());
TabBar.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CTab.Bar",
  "props": {
    "value": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "onChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};
var _default = TabBar;
exports.default = _default;